import type React from "react";
import { Settings } from "lucide-react";
import { Button } from "@planta-v2/pds-ui/button";
import { BackButton } from "@planta-v2/pds-ui/back-button";
import { i18n } from "@frontend/i18n";

interface ProfileHeaderProps {
  readonly onDirectoryClick: () => void;
  readonly onAccountClick: () => void;
  readonly showAccountButton: boolean;
}

export function ProfileHeader({
  onDirectoryClick,
  onAccountClick,
  showAccountButton,
}: ProfileHeaderProps): React.JSX.Element {
  return (
    <header className="flex items-start justify-between p-4 bg-surface shadow-xs shrink-0">
      <BackButton
        onClick={onDirectoryClick}
        data-testid="directory-header-button"
        label={i18n.t("user.profile.header.directory")}
      />
      {showAccountButton && (
        <Button
          variant="outline"
          onClick={onAccountClick}
          data-testid="account-header-button"
        >
          <Settings className="h-4 w-4" />
          {i18n.t("user.profile.header.account")}
        </Button>
      )}
    </header>
  );
}
